/**
 * 自动加载各种默认组件 及配置文件
 */
import Vue from "vue";
import store from "./store";
import cookies from 'js-cookie';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import apiAxios from "./apiAxios";
import globalFunc from './global.func';
import * as genesysui from '@genesys/ui';

import "@genesys/reader/cmdp-workshop-ult.js"
import "@genesys/reader/reader/intensive/cmdp-workshop-intensive"
import "@genesys/reader/reader/cmdata/reader-main.js"
import "@genesys/reader/reader/search/reader-main.js"
import "@genesys/reader/cmdp-reader.js"
import "@genesys/reader/reader/writer/reader-main.js"
import "@genesys/reader/reader/writer/reader-follow.js"
import "@genesys/reader/cmdp-workshop-ml.js"
import "@genesys/reader/reader/transfer/reader-main.js"
import "@genesys/reader/reader/perspective/cmdp-workshop-perspective"


Vue.use( Element );
Vue.use( genesysui );
Vue.use( cookies );

Vue.prototype.$api = apiAxios;
Vue.prototype.$func = globalFunc;
Vue.prototype.$store = store;
Vue.prototype.$cookies = cookies;
Vue.prototype.$EventBus = new Vue();

Vue.config.errorHandler = function( e, vm ){
    console.error( e )
}

window.$func    = globalFunc;
import './vueExtends';